import { OPEN_MODAL, CLOSE_MODAL } from "../constants/ActionTypes";

const initialState = {
  path: "",
  params: {},
};

export default function modal(state = initialState, action) {
  switch (action.type) {
    case OPEN_MODAL:
      return Object.assign({}, state, {
        path: action.path,
        params: action.params || {},
      });

    case CLOSE_MODAL:
      return Object.assign({}, state, {
        path: "",
        params: {},
      });

    default:
      return state;
  }

  return state;
}
